import { CanActivateFn, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../panelclient/services/user.service';
import { firstValueFrom } from 'rxjs';


export const guardBasic: CanActivateFn = async(route, state): Promise<boolean | UrlTree> => {
    const router = inject(Router);
    const userService = inject(UserService);

    const getUser = await firstValueFrom(userService.getConfigUser());

    if(((getUser?.configUser as any).basicoMenu) != true){
        console.log("E falso");
        return router.createUrlTree(['app', 'perfil'])
    }

    return true;
}